import { Quote } from "lucide-react";
import { Reveal, Eyebrow } from "@/components/mystic/Reveal";

const RELATOS = [
  {
    id: "mariana",
    nome: "Mariana Oliveira",
    idade: 34,
    texto:
      "Depois de uma separação, a saudade pode fazer a gente procurar respostas em lugares inesperados. Sempre tive curiosidade sobre as simpatias que minha avó contava.",
  },
  {
    id: "juliana",
    nome: "Juliana Martins",
    idade: 42,
    texto:
      "Minha avó dizia que as simpatias faziam parte das antigas tradições do amor. Conhecer essas histórias é uma forma de manter vivas as lembranças de outras gerações.",
  },
  {
    id: "fabricio",
    nome: "Fabrício Costa",
    idade: 38,
    texto:
      "Quando uma história de amor termina, nem sempre os sentimentos desaparecem. A esperança de uma conversa e de um novo começo pode continuar presente.",
  },
  {
    id: "patricia",
    nome: "Patrícia Almeida",
    idade: 46,
    texto:
      "Rosas, velas e antigas simpatias sempre despertaram minha curiosidade. Existe algo especial em conhecer os costumes que passaram de geração em geração.",
  },
  {
    id: "fernanda",
    nome: "Fernanda Ribeiro",
    idade: 29,
    texto:
      "Às vezes, o que mais desejamos é uma segunda chance para conversar, compreender o que aconteceu e encontrar um novo caminho para o coração.",
  },
  {
    id: "jessica",
    nome: "Jéssica Ferreira",
    idade: 36,
    texto:
      "Minha avó sempre dizia que o amor tinha seus mistérios e suas tradições. Cresci ouvindo histórias sobre simpatias e, até hoje, essas lembranças despertam minha curiosidade sobre os caminhos do coração.",
  },
];

export function Historias() {
  return (
    <section data-testid="historias-section" className="relative overflow-hidden bg-vinho">
      <div className="pointer-events-none absolute -right-32 top-0 h-96 w-96 rounded-full bg-borgonha/40 blur-3xl" />
      <div className="relative mx-auto max-w-7xl px-5 py-20 sm:px-8 sm:py-24 lg:px-14">
        <Reveal className="mx-auto max-w-3xl text-center">
          <Eyebrow>Histórias</Eyebrow>
          <h2 className="font-serif text-3xl font-semibold leading-tight text-creme sm:text-4xl lg:text-5xl">
            HISTÓRIAS DE AMOR, SAUDADE
            <br />
            <span className="gold-text italic">E ESPERANÇA</span>
          </h2>
          <p className="mt-5 font-serif text-lg italic text-rosa">
            Sentimentos e histórias que inspiram a busca por antigas tradições do amor.
          </p>
          <p data-testid="historias-aviso" className="mt-4 text-[0.65rem] uppercase tracking-[0.2em] text-creme/45">
            Relatos fictícios ilustrativos — não representam avaliações de compradores
          </p>
        </Reveal>

        <div className="mt-14 flex flex-wrap justify-center gap-6 sm:gap-8">
          {RELATOS.map((r, i) => (
            <Reveal
              key={r.id}
              delay={0.1 * i}
              className="w-full md:w-[calc(50%-1.5rem)] lg:w-[calc(33.333%-1.5rem)]"
            >
              <article
                data-testid={`historia-card-${r.id}`}
                className="flex h-full flex-col rounded-2xl border border-dourado/20 bg-carddark/70 p-7 transition-[transform,border-color,box-shadow] duration-500 hover:-translate-y-1.5 hover:border-dourado/45 hover:shadow-[0_20px_50px_-20px_rgba(214,175,98,0.3)]"
              >
                <Quote className="h-6 w-6 text-dourado/60" strokeWidth={1.5} aria-hidden="true" />
                <p className="mt-4 flex-1 font-serif text-base italic leading-relaxed text-creme/85 sm:text-lg">
                  “{r.texto}”
                </p>
                <footer className="mt-6 flex items-center gap-3 border-t border-dourado/15 pt-5">
                  <span
                    aria-hidden="true"
                    className="flex h-11 w-11 items-center justify-center rounded-full border border-dourado/50 bg-gradient-to-br from-borgonha to-vinho font-cinzel text-sm text-dourado"
                  >
                    {r.nome[0]}
                  </span>
                  <div>
                    <p className="text-sm font-semibold text-creme">{r.nome}</p>
                    <p className="text-xs text-rosa">{r.idade} anos</p>
                  </div>
                </footer>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
      <div className="h-16 bg-gradient-to-b from-transparent to-obsidian" aria-hidden="true" />
    </section>
  );
}
